import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertTitle, Box, Stack, Typography } from '@mui/material';
import React from 'react';

import { CloneWarningField } from '../../util/cloneWarnings';
import Checkbox from './Checkbox';

interface CloneFieldWarningsProps {
  warnings: CloneWarningField[];
}

// ADOPS-2722 — Warns the user which risky settings will be carried over when duplicating
// a line item or ad group. Deselectable fields render a checkbox (checked = copy to the
// clone); informational fields render a bullet pointing at their control elsewhere.
function CloneFieldWarnings({ warnings }: CloneFieldWarningsProps) {
  if (warnings.length === 0) {
    return null;
  }

  return (
    <Stack direction="row">
      <Alert severity="warning" icon={<FontAwesomeIcon icon={faTriangleExclamation} />} sx={{ width: '100%' }}>
        <AlertTitle>Review settings before duplicating</AlertTitle>
        <Typography variant="body2">
          The following settings from the original will be carried over. Uncheck any you do not want to copy.
        </Typography>
        <Stack spacing={1} mt={1}>
          {warnings.map((warning) => (
            <Box key={warning.fieldName}>
              {warning.deselectable ? (
                <Checkbox name={warning.fieldName} label={warning.label} />
              ) : (
                <Typography variant="body2" fontWeight="bold">
                  {warning.label}
                </Typography>
              )}
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: 'block', ml: warning.deselectable ? 4 : 0 }}
              >
                {warning.detail}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Alert>
    </Stack>
  );
}

export default CloneFieldWarnings;
